module.exports = __webpack_public_path__ + "static/media/notification-error.dee77758.svg";